import { render, staticRenderFns } from "./ViewEdit.vue?vue&type=template&id=bffb43d4&scoped=true&v-if=data&"
import script from "./ViewEdit.vue?vue&type=script&lang=js&"
export * from "./ViewEdit.vue?vue&type=script&lang=js&"
import style0 from "./ViewEdit.vue?vue&type=style&index=0&id=bffb43d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffb43d4",
  null
  
)

export default component.exports